import React from 'react'
import PropTypes from 'prop-types'
import Auth from 'services/auth/auth-service'
import Login from '..'
import Auth0Lock from 'auth0-lock'

const lock = new Auth0Lock(
  process.env.REACT_APP_AUTH0_CLIENT_ID,
  process.env.REACT_APP_AUTH0_DOMAIN,
  {
    auth: {
      responseType: 'token id_token',
      params: { scope: 'openid email profile' },
      redirect: false,
      allowedConnections: ['google-oauth2', 'facebook', 'twitter']
    }
  }
)

lock.on('authenticated', async function ({ accessToken }) {
  try {
    await Auth.loginWithAuth0(accessToken)
    // redirect back to dashboard
    window.location.href = '/'
  } catch (e) {
    console.error(e)
  }
})

class LoginContainer extends React.Component {
  constructor (props) {
    super(props)
    this.handleTwitterLoginClick = this.handleTwitterLoginClick.bind(this)
    this.handleFbLoginClick = this.handleFbLoginClick.bind(this)
    this.onAuth0LoginClick = this.onAuth0LoginClick.bind(this)
  }

  async handleTwitterLoginClick () {
    try {
      await Auth.login()
      // redirect back to dashboard
      this.props.router.replace('/')
    } catch (e) {
      console.error(e)
    }
  }

  async handleFbLoginClick () {
    try {
      await Auth.loginWithFacebook()
      // redirect back to dashboard
      this.props.router.replace('/fb-dashboard')
    } catch (e) {
      console.error(e)
    }
  }

  onAuth0LoginClick () {
    lock.show({
      allowedConnections: ['google-oauth2']
    })
  }

  render () {
    return (
      <Login
        onTwitterLoginClick={this.handleTwitterLoginClick}
        onFbLoginClick={this.handleFbLoginClick}
        onAuth0LoginClick={this.onAuth0LoginClick}
      />
    )
  }
}

LoginContainer.displayName = 'Login'

LoginContainer.propTypes = {
  router: PropTypes.object.isRequired
}

export default LoginContainer



// WEBPACK FOOTER //
// ./src/pages/login/container/index.js